/** Strip HTML tags without regex (linear time; avoids ReDoS on tag-like input). */
function stripHtmlTags(raw: string): string {
  let result = ''
  let i = 0
  while (i < raw.length) {
    if (raw[i] === '<') {
      const close = raw.indexOf('>', i + 1)
      if (close === -1) {
        result += raw.slice(i)
        break
      }
      i = close + 1
      continue
    }
    result += raw[i]
    i += 1
  }
  return result
}

/** Plain-text length for rich-text HTML (matches campaign-service instrument validation). */
export function plainTextLength(raw: string): number {
  return stripHtmlTags(raw).trim().length
}
